import React from 'react';
import classNames from 'classnames';
import styles from './StackedDoubleInfoBox.module.scss';
import Trend from '../Trend/Trend';

export interface StackedInfoBoxItem {
  label: string;
  score: string;
  trend: number;
}

export interface StackedDoubleInfoBoxProps {
  data: StackedInfoBoxItem[];
  className?: string;
}

const StackedDoubleInfoBox: React.FC<StackedDoubleInfoBoxProps> = ({ data, className }) => {
  return (
    <div className={classNames(styles.root, className)}>
      {data.map(item => (
        <div key={item.label} className={styles.item}>
          <div className={classNames('typo-text-14--bold text-full pb-36')}>{item.label}</div>
          <div className="flex flex-col gap-y-12 mt-auto">
            <div className="typo-title-24 xl:typo-title-36 text-full">{item.score}</div>
            <Trend percentage={item.trend} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default StackedDoubleInfoBox;
